export default __webpack_public_path__ + "static/media/Snd5.accb901f.mp3";